export enum FeedbackSentiment {
  POSITIVE = 'positive',
  NEGATIVE = 'negative'
}

export interface AppointmentAttendanceFeedback {
  id: string;
  appointment_attendance_id: string;
  appointment_id: string;
  appointment_start_at: string;
  appointment_end_at: string;
  appointment_type_name: string;
  sentiment: FeedbackSentiment;
  appointment_reason_name: string | null;
  other_reason: string | null;
  comment: string | null;
  created_at: string;
}
